import React from 'react';
import { useTheme } from '@mui/material';
import { Link as RRLink } from 'react-router-dom';
import { Box, Text } from 'pounceV2';
import { SettingsItem } from '../constants';

interface SettingsSidebarItemV3Props {
  item: SettingsItem;
  isActive: boolean;
}

const SettingsSidebarItemV3: React.FC<SettingsSidebarItemV3Props> = ({ item, isActive }) => {
  const {
    palette: { tokens, componentTokens },
  } = useTheme();

  return (
    <Box
      as={RRLink}
      to={item.to}
      // Intra-settings navigation uses `replace` so the whole session
      // collapses into a single browser-history entry. Browser-back
      // from settings exits to the prior page, not through every
      // sidebar item the user clicked.
      replace
      data-tid={`settings-sidebar-item-${item.id}`}
      aria-current={isActive ? 'page' : undefined}
      aria-label={`Settings: ${item.label}`}
    >
      <Box
        px={4}
        py={2}
        borderRadius="small"
        height={36}
        display="flex"
        alignItems="center"
        backgroundColor={
          isActive
            ? componentTokens.navigation.colors.backgroundRowItems.selectedSubtle
            : 'transparent'
        }
        color={
          isActive
            ? componentTokens.navigation.colors.text.selectedSubtle
            : tokens.content.text.neutral[2]
        }
        transition="background-color 150ms ease, color 150ms ease"
        sx={{
          '&:hover': isActive
            ? undefined
            : {
                backgroundColor: componentTokens.navigation.colors.backgroundRowItems.hover,
                color: componentTokens.navigation.colors.text.hover,
              },
        }}
      >
        <Text fontSize="medium" fontWeight={isActive ? 'medium' : 'normal'} truncated>
          {item.label}
        </Text>
      </Box>
    </Box>
  );
};

export default React.memo(SettingsSidebarItemV3);
